export const convertUTCToLocal = (utcDateString) => {
    if (!utcDateString) return null;

    // Create Date object from UTC string
    const utcDate = new Date(utcDateString);

    // Extract UTC date components
    const year = utcDate.getUTCFullYear();
    const month = utcDate.getUTCMonth() + 1; // Months are zero-based
    const day = utcDate.getUTCDate();

    // Format as YYYY-MM-DD
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const convertISOToLocal = (isoDateString) => {
    if (!isoDateString) return null; // Handle null or invalid input
    const date = new Date(isoDateString);
    return date.toLocaleString();
};
